import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getOnboardingInsights } from './apis';
import { OnboardingInsightsViewModel } from './types';

export function useGetOnboardingInsights(
  options?: Omit<UseQueryOptions<OnboardingInsightsViewModel, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<OnboardingInsightsViewModel, Error>({
    queryKey: ['agencyOnboardingInsights'],
    queryFn: () => getOnboardingInsights(),
    ...options
  });
}
